<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'">
  <div app-theme-option-content>
    <app-number [value]="themeOptions.options().tooltips.cornerRadius" (sendValue)="receiveValue($event)" [color]="color" [min]="0" [max]="12" [step]="2"></app-number>
  </div>
</app-theme-option>